export default __webpack_public_path__ + "static/media/char_head_prem_013.bd00c777.png";